import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    menuContainer: {
        minWidth: '260px',
        maxWidth: '290px',
        overflow: 'visible',
        position: 'relative',
        paddingTop: '3px',
        paddingBottom: '3px',
    },
    menuItem: {
        padding: '7px 12px 7px 8px',
        cursor: 'pointer',
        height: '28px',
        overflow: 'hidden',
        borderLeft: '1px solid transparent',
        '&:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.04),
        },
        '&.selected': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.04),
            borderLeftColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.64),
            color: (theme: Theme) => theme.palette.primary.main,
        },
    },
    checkIcon: {
        fontSize: '16px',
        color: (theme: Theme) => theme.palette.primary.main,
    },
    noCheck: {
        width: '16px',
        height: '16px',
    },
    iconButton: {
        padding: '0px 4px 0px 8px',
        height: '24px',
        borderRadius: '3px',
        border: '1px solid',
        borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.16),
        fontSize: 13,
        gap: '4px',
        backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.04),
        '&:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        },
        '&.active-state, &.active-state:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.16),
            borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.24),
        },
    },
    domainBadge: {
        display: 'inline-flex',
        border: '1px solid',
        borderRadius: '3px',
        borderColor: (theme: Theme) => theme.palette.primary.main,
        padding: '4px 8px',
        alignItems: 'center',
        gap: '4px',
        color: (theme: Theme) => theme.palette.primary.main,
        backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.04),
        '&:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.1),
        },
    },
    closeIcon: {
        cursor: 'pointer',
        height: '16px',
    },
    extraMenu: {
        position: 'absolute',
        backgroundColor: 'background.default',
        color: 'text.primary',
        borderRadius: '4px',
        minWidth: '280px',
        maxWidth: '320px',
        padding: '16px',
        boxShadow: (theme: Theme) => `0px 4px 16px 0px ${alpha(theme.palette.text.primary, 0.24)}`,
    },
    examplesList: {
        marginBottom: '12px',
    },
    examplesItem: {
        backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.04)),
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.24)),
        py: 1,
        pr: 1,
        pl: 1.5,
        borderRadius: '4px',
        color: (theme: Theme) => theme.palette.primary.main,
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
            borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.6)),
            backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.08)),
        },
    },
    examplesItemIcon: {
        ml: 1,
        flexShrink: 0,
        display: 'inline-flex',
    },
    groupHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '4px 8px 4px 40px',
        fontSize: '11px',
        fontWeight: 600,
        color: (theme: Theme) => theme.palette.text.primary,
        borderTop: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        cursor: 'pointer',
        userSelect: 'none' as const,
        '&:hover': {
            color: (theme: Theme) => alpha(theme.palette.text.primary, 0.7),
        },
    },
    groupHeaderChevron: {
        fontSize: '12px',
        transition: 'transform 0.15s ease',
    },
    dropdownPanel: { '.MuiPaper-root': { overflow: 'visible' } },
};
